export const verifyError = (error: unknown): Error => {
	if (error instanceof Error) {
		return error;
	}

	return new Error("An error occurred.");
};
